import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, DatePicker, Popover } from '@shopify/polaris'
import moment from 'moment'
import styled from 'styled-components'
import get from 'lodash/get'

import { setAnalyticsDatesRange } from 'actions/shopifyAnalyticsAC'
import { fetchAnalytics, getDefaultAnalyticsDateRange } from 'controllers/shopifyDashboard'
import { SHOPIFY_TEXT } from 'components/styles'

const DatePickerContainer = styled.div`
  margin: 1em;
  font-size: 10px;
`
const ButtonContent = styled.div`
  display: flex;
`
const ButtonText = styled.div`
  margin-right: 0.5em;
`
const Icon = styled.div`
  display:flex;
  margin-right: 2em;
  height:1em;
  width:1em;
  max-height:100%;
  max-width:100%;
  margin:auto;
  justify-content: center;
  align-items: center;
  fill: ${SHOPIFY_TEXT};
  transform: rotate(-90deg);
`

class DateRangePicker extends Component {
  constructor (props) {
    super(props)
    this.state = {
      month: 0,
      year: 2018,
      active: false,
      today: null,
      clickCount: 0
    }
    this.onMonthChange = this.onMonthChange.bind(this)
    this.onChange = this.onChange.bind(this)
    this.toggleActiveState = this.toggleActiveState.bind(this)
  }

  componentWillMount () {
    const {shopifyAnalytics, dispatch} = this.props
    let { datesRange } = shopifyAnalytics
    if (!datesRange) {
      datesRange = getDefaultAnalyticsDateRange()
      dispatch(setAnalyticsDatesRange(datesRange))
    }
    const month = datesRange.start.getMonth()
    const year = datesRange.start.getFullYear()
    const today = new Date(Date.now())
    this.setState({today: today, month: month, year: year})
  }

  onMonthChange (newMonth, newYear) {
    this.setState({month: newMonth, year: newYear})
  }

  onClose () {
    this.setState({})
  }

  toggleActiveState () {
    this.setState((prevState) => {
      return {active: !prevState.active}
    })
  }

  onChange (date) {
    const { dispatch } = this.props
    dispatch(setAnalyticsDatesRange(date))
    this.setState((prevState) => {
      let clickCount = prevState.clickCount + 1
      if (clickCount === 2) {
        dispatch(fetchAnalytics(date))
        return ({clickCount: 0, active: false})
      }
      return {clickCount: clickCount}
    })
  }

  renderDatePicker () {
    const { shopifyAnalytics, user } = this.props
    const publishDate = get(user, 'state') === 'activated' ? get(user, 'publishedFirstAt', Date.now()) : Date.now()
    return (
      <DatePickerContainer>
        <DatePicker
          selected={shopifyAnalytics.datesRange}
          month={this.state.month}
          year={this.state.year}
          multiMonth
          onChange={this.onChange}
          onMonthChange={this.onMonthChange}
          disableDatesAfter={this.state.today}
          disableDatesBefore={publishDate}
        />
      </DatePickerContainer>
    )
  }

  datesRangeToString () {
    const { shopifyAnalytics } = this.props
    const datesRange = shopifyAnalytics.datesRange
    const startDate = moment(datesRange.start).format('MMM DD, YYYY')
    const endDate = moment(datesRange.end).format('MMM DD, YYYY')
    return (
      <ButtonContent>
        <ButtonText>{`${startDate} – ${endDate}`}</ButtonText>
        <Icon>
          <svg className='Polaris-Icon__Svg' viewBox='0 0 20 20'>
            <path d='M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L8.414 10l4.293 4.293A.999.999 0 0 1 12 16' />
          </svg>
        </Icon>
      </ButtonContent>
    )
  }

  render () {
    return (
      <Popover
        active={this.state.active}
        activator={
          <Button onClick={this.toggleActiveState}>
            {this.datesRangeToString()}
          </Button>}
        onClose={() => null}
      >
        {this.renderDatePicker()}
      </Popover>
    )
  }
}

DateRangePicker.propTypes = {
  shopifyAnalytics: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  shopifyAnalytics: state.shopifyAnalytics,
  user: state.user
})

export default connect(mapStateToProps)(DateRangePicker)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/DateRangePicker.js